import { PatientDetailPresenter } from '../../../../generic/patient-detail/patient-detail.presenter';
import { MonitoringKeys } from '../monitoring.key';
import { MonitoringDetailKeys } from './monitoring-detail.key';
/**
 * O detalhe aberto pelo PROFISSIONAL, a partir dos Monitoramentos Compartilhados.
 *
 * Uma das duas montagens do apresentador generico. Tudo o que a distingue da outra
 * esta no `mount`; o comportamento inteiro mora na base.
 *
 * `get mount()` e nao campo: acessor vive no PROTOTIPO e ja existe quando o
 * construtor da base roda. Campo de subclasse so nasce depois - e um factory
 * chamado no construtor da base resolveria isso, mas congelaria o valor errado para
 * sempre se algum dia lesse um campo da subclasse. O getter nao tem esse risco.
 */
export class MonitoringDetailPresenter extends PatientDetailPresenter {
    get mount() {
        return MOUNT;
    }
}
const MOUNT = {
    section: 'monitoring',
    title: 'Monitoramentos Compartilhados',
    subtitle: 'Lista de colaboradores que compartilharam seus monitoramentos com você',
    backLabel: 'Monitoramentos Compartilhados',
    keys: (app, intent) => new MonitoringDetailKeys(app, intent),
    back: async (app) => {
        await MonitoringKeys.of(app).flip();
    }
};
//# sourceMappingURL=monitoring-detail.presenter.js.map